var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"captcha-wrapper"},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":_vm.elementId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }